import { LOADER_START, LOADER_STOP } from '../actions/actionTypes';

export default function loader(state = {}, action) {
  switch (action.type) {
      case LOADER_START:
          return {
              loading: true,
          };
      case LOADER_STOP:
          return {
            loading: false,
          };
      default:
          return state
  }
}